<div class="container">

  <div class="row justify-content-center">
    <div class="col-auto">
      <mat-form-field class="mt-1">
        <mat-label>Meses</mat-label>
        <mat-select multiple [ngModel]="monthsSelected"
          (selectionChange)="onChangeMonth($event)" #monthSelect>
          <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
            Todos
          </mat-checkbox>
          <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="requestReady === false">
    <div class="row">
      <div class="col">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="requestReady === true">
    <div class="cf-chart-grid cf-chart-grid--even">

      <!-- Proveedor al que mas le compro -->
      <div class="cf-chart-card">
        <div class="cf-chart-card__header">
          <div class="cf-chart-card__icon cf-chart-card__icon--red">
            <mat-icon>show_chart</mat-icon>
          </div>
          <div class="cf-chart-card__title-wrap">
            <p class="cf-chart-card__title">Proveedores a los que más le compro</p>
            <p class="cf-chart-card__sub">Total comprado por proveedor</p>
          </div>
        </div>
        <div class="cf-chart-canvas-wrap">
          <canvas baseChart
            [type]="chartType"
            [data]="chartDataSupplierFromWhomIBuyTheMost"
            [options]="chartOptionsSupplierFromWhomIBuyTheMost">
          </canvas>
        </div>
      </div>

      <!-- Proveedor al que mas le debo -->
      <div class="cf-chart-card">
        <div class="cf-chart-card__header">
          <div class="cf-chart-card__icon">
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="cf-chart-card__title-wrap">
            <p class="cf-chart-card__title">Proveedores a los que más le debo</p>
            <p class="cf-chart-card__sub">Deuda pendiente por proveedor</p>
          </div>
        </div>
        <div class="cf-chart-canvas-wrap">
          <canvas baseChart
            [type]="chartType"
            [data]="chartDataSupplierToWhomIOweTheMost"
            [options]="chartOptionsSupplierToWhomIOweTheMost">
          </canvas>
        </div>
      </div>

    </div>
  </ng-container>

</div>
